import React, { createContext, useContext, useEffect, useState } from 'react';

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: undefined
  });

  useEffect(() => {
    const handleScreenResize = () => {
      setScreenSize({
        width: window.innerWidth
      });
    };

    window.addEventListener('resize', handleScreenResize);

    // Call handler right away so state gets updated with initial window size
    handleScreenResize();

    return () => window.removeEventListener('resize', handleScreenResize);
  }, []);

  return screenSize;
};

const viewportContext = createContext({});

export const ViewportProvider = ({ children }) => {
  const screenSize = useScreenSize();

  return (
    <viewportContext.Provider value={screenSize}>
      {children}
    </viewportContext.Provider>
  );
};

export const useViewport = () => useContext(viewportContext);



// WEBPACK FOOTER //
// ./src/helpers/ViewportContext.js